export default __webpack_public_path__ + "static/media/LCF-kids-club-ceret.e70b1bd9.webp";